import { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import styleData from "./SettlementTaxpayerDebt.module.css";

import MainContent from "../../../layouts/maincontent/MainContent";

import LoadingSpinner from "../../../components/Loading/LoadingSpinner";
import disputeInfo from "../../../assets/img/Icon feather-file-text.png";
// import walletAdd from "../../../assets/img/Wallet-pana.png";
import Pagination, {
  PaginationTax,
} from "../../../shared/pagination/Pagination";
import { useLocation } from "react-router-dom";
import { get, post } from "../../../adapters/xhr/api";
import Claims from "../claims";
import DebtSupportingDocuments from "../../../components/UnifiedTaxDeclaration/debtSupportingDocuments";

const SettlementPaymenAccountDebtTaxpayerBehalf = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [units, setUnits] = useState([]);
  const [wallet, setWallet] = useState(0);
  const [showFiles, setShowFiles] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [backendError, setBackendError] = useState(null);

  const [isSubmitButtonActive, setIsSubmitButtonActive] = useState(false);
  const [activeTab, setActiveTab] = useState("payments");
  const [unitId, setUnitId] = useState(0);
  const [declarationStatus, setDeclarationStatus] = useState(null);
  const [documents, setDocuments] = useState([]);
  const [isAmountMissing, setIsAmountMissing] = useState(false);
  const [limit, setLimit] = useState(20);
  const [pagination, setPagination] = useState(null);
  const [selectedUnits, setSelectedUnits] = useState([]);
  const selectedUnitsRef = useRef(selectedUnits);

  useEffect(() => {
    selectedUnitsRef.current = selectedUnits;
  }, [selectedUnits]);

  const location = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();

  const [error, setError] = useState(null);

  useEffect(() => {
    if (location?.state?.activeTab) {
      setActiveTab(location?.state?.activeTab);
    }
  }, [location]);

  const getPaymentUnderAccountUnitsList = async (
    page = 1,
    newLimit,
    isFirstLoad = false,
  ) => {
    try {
      const perPage = newLimit || limit;

      // Build URL conditionally
      let url = `api/declaration-system/under-debt-properties/list/${id}?page=${page}`;
      if (!isFirstLoad) {
        url += `&per_page=${perPage}`;
      }

      const response = await get(url);
      const fetchedUnits = response?.data?.data || [];

      const processedUnits = fetchedUnits.map((unit) => {
        const unitKey = `${unit.id}-${unit.type}`;
        const existingSelection = selectedUnitsRef.current.find(
          (wu) => `${wu.id}-${wu.type}` === unitKey,
        );

        if (existingSelection) {
          return {
            ...unit,
            is_checked: true,
            amount:
              existingSelection.amount !== undefined
                ? existingSelection.amount
                : unit.amount,
            paid_by_wallet: existingSelection.paid_by_wallet,
          };
        }

        return unit;
      });

      setUnits(processedUnits);
      setPagination(response?.data?.pagination);
      setLimit(response?.data?.pagination?.per_page);

      setDeclarationStatus(parseInt(response?.data?.declaration_status_id));
      setWallet(response?.data?.wallet_balance);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (activeTab === "payments") {
      getPaymentUnderAccountUnitsList(1, limit, true);
    }
  }, [activeTab, showFiles]);

  const handlePageChange = (page) => {
    getPaymentUnderAccountUnitsList(page, limit);
  };

  const handleLimitChange = (newLimit) => {
    setLimit(newLimit);
    getPaymentUnderAccountUnitsList(1, newLimit);
  };

  useEffect(() => {
    setIsSubmitButtonActive(
      selectedUnits.length > 0 &&
        selectedUnits.every(
          (unit) =>
            unit?.amount !== null &&
            unit?.amount !== "" &&
            Number(unit?.amount) > 0,
        ),
    );
  }, [selectedUnits]);

  const handleShowFiles = (element) => {
    setShowFiles(true);
    setUnitId(element?.id);
    setDocuments(element?.debt_supporting_document);
  };

  const handleIsCheckedChange = (unit, e) => {
    const checkValue = e.target.checked;
    const unitKey = `${unit.id}-${unit.type}`;

    if (!checkValue) {
      setSelectedUnits((prev) =>
        prev.filter((wu) => `${wu.id}-${wu.type}` !== unitKey),
      );
      setUnits((prev) =>
        prev.map((u) =>
          u?.id == unit?.id && u?.type == unit?.type
            ? {
                ...u,
                is_checked: false,
                amount: "",
              }
            : u,
        ),
      );
    } else {
      setSelectedUnits((prev) => {
        const alreadyExists = prev.some(
          (wu) => `${wu.id}-${wu.type}` === unitKey,
        );
        if (alreadyExists) return prev;
        return [
          ...prev,
          {
            id: unit.id,
            type: unit.type,
            property_type_id: unit.property_type_id,
            paid_by_wallet: false,
            amount: unit.amount || "",
          },
        ];
      });
      setUnits((prev) =>
        prev.map((u) =>
          u?.id == unit?.id && u?.type == unit?.type
            ? {
                ...u,
                is_checked: true,
              }
            : u,
        ),
      );
    }
  };

  const handleIsPaidByWalletChange = (unit, e) => {
    const checkedValue = e.target.checked;
    const unitAmount = Number(unit?.amount || 0);
    const currentWallet = Number(wallet || 0);

    if (!unitAmount || unitAmount <= 0) return;

    if (checkedValue && currentWallet >= 1) {
      setUnits((prev) =>
        prev.map((u) =>
          u?.id == unit?.id && u?.type == unit?.type
            ? { ...u, paid_by_wallet: true }
            : u,
        ),
      );
      setSelectedUnits((prev) =>
        prev.map((su) =>
          su.id === unit.id && su.type === unit.type
            ? { ...su, paid_by_wallet: true }
            : su,
        ),
      );
      setWallet((prev) => Number(prev || 0) - unitAmount);
      return;
    }

    if (!checkedValue) {
      setUnits((prev) =>
        prev.map((u) =>
          u?.id == unit?.id && u?.type == unit?.type
            ? { ...u, paid_by_wallet: false }
            : u,
        ),
      );
      setSelectedUnits((prev) =>
        prev.map((su) =>
          su.id === unit.id && su.type === unit.type
            ? { ...su, paid_by_wallet: false }
            : su,
        ),
      );
      setWallet((prev) => Number(prev || 0) + unitAmount);
    }
  };

  const handleChangeAmountToBePaid = (unit, e) => {
    const inputValue = e.target.value;

    const regex = /^(?!0+(?:\.0{0,2})?$)\d{1,19}(?:\.\d{0,2})?$/;

    // Allow empty string
    if (inputValue === "") {
      setUnits((prev) =>
        prev.map((u) =>
          u?.id === unit?.id && u?.type === unit?.type
            ? { ...u, amount: null }
            : u,
        ),
      );
      setSelectedUnits((prev) =>
        prev.map((su) =>
          su.id === unit.id && su.type === unit.type
            ? { ...su, amount: null }
            : su,
        ),
      );
      return;
    }

    if (!regex.test(inputValue)) return;

    setUnits((prev) =>
      prev.map((u) =>
        u?.id === unit?.id && u?.type === unit?.type
          ? { ...u, amount: inputValue }
          : u,
      ),
    );
    setSelectedUnits((prev) =>
      prev.map((su) =>
        su.id === unit.id && su.type === unit.type
          ? { ...su, amount: inputValue }
          : su,
      ),
    );
  };

  const data =
    units?.length > 0 &&
    units?.map((element, index) => (
      <tr
        key={`${element?.id}-${element?.type}-${index}`}
        className={` ${element?.is_exist_in_claim && "opacity-50"}`}
      >
        <td data-label="">
          <input
            type="checkbox"
            className={`form-check-input ${styleData["checkboxEnabled"]}`}
            checked={!!element?.is_checked}
            onChange={(e) => handleIsCheckedChange(element, e)}
            style={{ marginRight: "10px" }}
            aria-label="تحديد الصف"
            // disabled={element?.is_exist_in_claim}
          />
        </td>

        <td data-label="المحافظة">{element?.governorate || "-"}</td>
        <td data-label="عنوان العقار">
          {element?.correct_astrick_colour && (
            <span className={`${element?.correct_astrick_colour} mr-1`}>*</span>
          )}

          {element?.full_address}
        </td>

        <td data-label="نوع العقار">{element?.property_type || "-"}</td>

        <td data-label="رقم العقار">{element?.property_number || "-"}</td>

        <td data-label="رقم الوحدة">{element?.unit_number || "-"}</td>

        <td data-label="اسم المنشأة / النشاط التجاري">
          {element?.property_name || "-"}
        </td>

        <td data-label="نوع نشاط المنشأة/ الوحدة">
          {element?.activity_type || "-"}
        </td>

        {/* SMALL COLUMNS (width controlled by colgroup) */}
        <td data-label="*المبلغ المطلوب سداده">
          <input
            type="text"
            value={element?.amount ?? ""}
            onChange={(e) => handleChangeAmountToBePaid(element, e)}
            className="p-2 rounded"
            style={{
              backgroundColor: "#F5F5F5",
              border: "1px solid #CFCFCF",
              width: `${(element?.amount?.toString().length || 1) + 2}ch`,
            }}
            placeholder="0"
            inputMode="decimal"
            disabled={!element?.is_checked}
          />
        </td>

        <td data-label="المبلغ الجاري سداده">
          <span
            className="p-2 rounded"
            style={{ backgroundColor: "#F5F5F5", border: "1px solid #CFCFCF" }}
          >
            {element?.required_amount ?? "0"}
          </span>
        </td>

        <td data-label="المبلغ المسدد">
          <span
            className="p-2 rounded"
            style={{ backgroundColor: "#F5F5F5", border: "1px solid #CFCFCF" }}
          >
            {element?.paid_amount ?? "0"}
          </span>
        </td>

        <td data-label="مستندات دالة على المديونية">
          <button
            onClick={() => handleShowFiles(element)}
            style={{ backgroundColor: "transparent", border: "0px" }}
          >
            <img src={disputeInfo} className="img-fluid w-8 h-8" />
          </button>
        </td>

        {/* <td data-label="السداد من حساب التسويات">
          {(() => {
            const amountToPay = Number(element?.amount || 0);
            const isWalletCheckboxDisabled =
              element?.is_paid_by_wallet_disabled ||
              element?.is_exist_in_claim ||
              !element?.is_checked ||
              amountToPay <= 0;

            return (
              <input
                type="checkbox"
                className={`form-check-input ${element?.is_paid_by_wallet_disabled ? styleData["checkboxDisabled"] : styleData["checkboxEnabled"]}`}
                checked={!!element?.paid_by_wallet}
                disabled={isWalletCheckboxDisabled}
                onChange={(e) => handleIsPaidByWalletChange(element, e)}
                aria-label="سداد من حساب التسويات"
              />
            );
          })()}
        </td> */}
      </tr>
    ));

  const handleSubmit = async () => {
    if (
      selectedUnits.length === 0 ||
      !selectedUnits.every(
        (unit) =>
          unit?.amount !== null &&
          unit?.amount !== "" &&
          Number(unit?.amount) > 0,
      )
    ) {
      setIsAmountMissing(true);
      return;
    } else {
      setIsAmountMissing(false);
    }
    try {
      setBackendError(null);
      setIsSubmitting(true);
      let unitsToBeSubmitted = selectedUnits.map((unit) => ({
        id: unit?.id,
        property_type_id: unit?.property_type_id,
        amount: unit?.amount,
        paid_by_wallet: !!unit?.paid_by_wallet,
      }));
      const data = {
        declaration_id: id,
        property_data: unitsToBeSubmitted,
      };

      let url = `api/declaration-system/declarations/taxpayers-knowledge/claim`;

      await post(
        url,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        },
        data,
      );
      setSelectedUnits([]);
      // getPaymentUnderAccountUnitsList();
      setActiveTab("claims");
      setIsSubmitting(false);
    } catch (error) {
      setBackendError(
        error.response?.data?.message ||
          error.response?.data?.data?.message ||
          "لا يمكن إنشاء طلب سداد لعدم وجود بعض الوحدات/ المنشآت في الإقرار",
      );
      setIsSubmitting(false);
    }
  };

  return (
    <MainContent>
      {backendError && (
        <div
          className="alert alert-danger mt-3 w-75 mx-auto"
          id="backend_error"
          role="alert"
        >
          {backendError}
        </div>
      )}
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <>
          {showFiles ? (
            <section className={`${styleData.listData}`}>
              <DebtSupportingDocuments
                setShowFiles={setShowFiles}
                unitId={unitId}
                setUnits={setUnits}
                documents={documents}
                declarationStatus={declarationStatus}
                declarationId={id}
              />
            </section>
          ) : (
            <section className={`${styleData.listData}`}>
              <div className="container pt-4">
                <div className={styleData.box}>
                  {isAmountMissing && (
                    <div
                      className="alert alert-danger mt-3"
                      id="amount_error"
                      role="alert"
                    >
                      يجب ادخال المبلغ المطلوب سداده
                    </div>
                  )}
                  <div className={`${styleData["box-header"]}`}>
                    <div className="d-flex align-items-center flex-wrap">
                      <Link
                        className={`${styleData["btn-arrow"]} ms-3`}
                        to={
                          location.pathname.includes("list-data")
                            ? `/tax-declaration/list-data`
                            : `/settlement-account-debt`
                        }
                      >
                        <i className="fa-solid fa-arrow-right mt-1"></i>
                      </Link>

                      {/* Responsive Tabs */}
                      <div className={`ms-2 ${styleData["tabs-wrapper"]}`}>
                        <div
                          className={`${styleData["tab-item"]} ${
                            activeTab === "payments" ? styleData["active"] : ""
                          }`}
                          onClick={() => setActiveTab("payments")}
                        >
                          <h3 className="mb-0 ms-2 fw-bold">
                            بيانات الدفع تحت حساب المديونية{" "}
                          </h3>
                        </div>

                        <div
                          className={`${styleData["tab-item"]} ${
                            activeTab === "claims" ? styleData["active"] : ""
                          }`}
                          onClick={() => setActiveTab("claims")}
                        >
                          <h3 className="mb-0 ms-2 fw-bold">طلبات السداد</h3>
                        </div>
                      </div>
                    </div>

                    {activeTab === "payments" && (
                      <div>
                        {declarationStatus !== 1 && (
                          <button
                            className={`${
                              isSubmitButtonActive
                                ? styleData["btn-request"]
                                : styleData["btn-request-disabled"]
                            }`}
                            id="add_declaration_button"
                            onClick={handleSubmit}
                            disabled={isSubmitting}
                          >
                            إصدار طلب سداد
                          </button>
                        )}
                      </div>
                    )}
                  </div>

                  {location?.state?.message && (
                    <div className="alert alert-danger mt-2 text-center w-25 mx-auto">
                      <h3 className="fs-5">{location?.state?.message} </h3>
                    </div>
                  )}

                  <div>
                    {activeTab === "payments" && (
                      <>
                        <div className={`${styleData["box-body"]}  mt-3`}>
                          <div
                            className={`${styleData["table-responsive"]} table-responsive `}
                          >
                            <table className={`${styleData["table"]} table`}>
                              <thead>
                                <tr>
                                  <th scope="col"></th>
                                  <th scope="col">المحافظة</th>
                                  <th scope="col">عنوان العقار</th>
                                  <th scope="col">نوع العقار</th>
                                  <th scope="col">رقم العقار</th>
                                  <th scope="col">رقم الوحدة</th>
                                  <th scope="col">
                                    اسم المنشأة/ النشاط التجاري
                                  </th>
                                  <th scope="col">نوع نشاط المنشأة/ الوحدة</th>
                                  <th scope="col">المبلغ المطلوب سداده*</th>
                                  <th scope="col">المبلغ الجاري سداده</th>
                                  <th scope="col">المبلغ المسدد</th>
                                  <th scope="col">
                                    مستندات دالة على المديونية
                                  </th>
                                  {/* <th scope="col">السداد من حساب التسويات</th> */}
                                </tr>
                              </thead>

                              <tbody>
                                {data?.length > 0 ? (
                                  data
                                ) : (
                                  <tr>
                                    <td colSpan={10} className="h5 text-center">
                                      {error}
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                        {pagination && (
                          <PaginationTax
                            limit={limit}
                            count={pagination?.total}
                            active={pagination?.current_page}
                            callback={handlePageChange}
                            handleLimitChange={handleLimitChange}
                          />
                        )}
                      </>
                    )}

                    {activeTab === "claims" && (
                      <>
                        {/* Put your claims tab content here */}
                        <Claims />
                        {/* <div className="text-center text-muted py-4">
                            <h5>لا توجد طلبات سداد حالياً</h5>
                          </div> */}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </section>
          )}
        </>
      )}
    </MainContent>
  );
};

export default SettlementPaymenAccountDebtTaxpayerBehalf;
